import { render, staticRenderFns } from "./pcat1.vue?vue&type=template&id=17f567f0"
import script from "./pcat1.vue?vue&type=script&lang=js"
export * from "./pcat1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports